<template>
    <section class="ui-tag-line" :style="[textSizeCss, colorCss, radiusCss, backgroundCss]">
		<strong v-if="title">{{ title }}</strong>
		{{ text }}
	</section>
</template>

<script>
    export default {
		name: 'ui-tag-line',
		components: {},
		props:{
			/**
			 * Utilize para definir o texto da tag
			 */
			text: {
				type: String,
				required: false,
			},
			/**
			 * Utilize para definir um label para a tag
			 */
			title: {
				type: String,
				required: false,
			},
			/**
			 * Utilize para definir a cor da tag
			 */
            color: {
				type: String,
				required: false,
				default: '#777d97'
			},
			/**
			 * Utilize para definir a cor da tag
			 */
            background: {
				type: String,
				required: false,
				default: null
			},
			/**
			 * Utilize para definir o tamanho do texto da tag.
			 */
			textSize: {
				required: false,
				default: 10
			},
			/**
			 * Utilize para definir o tamanho do texto da tag.
			 */
			radius: {
				required: false,
				default: 20
			},
			
		},
		data() {
            return {
				colorCss: {
					borderColor: this.color,
					color: this.color
				},
				textSizeCss: {
					fontSize: this.textSize + 'px'
				},
				radiusCss: {
					borderRadius: this.radius + 'px'
				},
				backgroundCss: {
					backgroundColor: this.background
				},
            }
		},
		
	};
</script>

<style lang="stylus" scoped>
	@import './styles.styl';

</style>
